/**
 * Created by niko on 9/24/15.
 */

'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const RegionalInfoModel = require('../models/RegionalInfoModel');

class RegionalInfoStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this._error = null;
        this._model = new RegionalInfoModel();
    }

    /**
     * Returns RegionalInfoModel representing regional information fetched by users IP.
     * @return {*}
     */
    getRegionalInfoModel() {
        return this._model;
    }

    getCountryCode() {
        return this._model.get('countryCode');
    }

    getRegionalInfo() {
        return this._model.toJSON();
    }

    onRegionalInfoLoaded() {
        this._error = null;
        this._model.trigger('regionalInfo:loaded');
        this.emitChange();
    }

    /**
     * Handler for errors when performing actions
     * @param error {object} The error object
     */
    onRegionalInfoError(error) {
        this._error = error;
        this._model.trigger('regionalInfo:error');
        this.emitChange();
    }
}

RegionalInfoStore.storeName = 'RegionalInfoStore';

RegionalInfoStore.handlers = {
    'regionalInfo:loaded': 'onRegionalInfoLoaded',
    'regionalInfo:error': 'onRegionalInfoError',
};

module.exports = RegionalInfoStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/RegionalInfoStore.es.js